export const getVideoTimeStamps = (t: any) => {
  return [
    {
      time: 12,
      displayTime: "00:12",
      description: t("timestamp1"),
    },
    {
      time: 49,
      displayTime: "00:49",
      description: t("timestamp2"),
    },
    {
      time: 137,
      displayTime: "02:17",
      description: t("timestamp3"),
    },
    {
      time: 184,
      displayTime: "03:04",
      description: t("timestamp4"),
    },
    {
      time: 246,
      displayTime: "04:06",
      description: t("timestamp5"),
    },
    {
      time: 259,
      displayTime: "04:19",
      description: t("timestamp6"),
    },
    {
      time: 360,
      displayTime: "06:00",
      description: t("timestamp7"),
    },
    {
      time: 410,
      displayTime: "06:50",
      description: t("timestamp8"),
    },
    {
      time: 427,
      displayTime: "07:07",
      description: t("timestamp9"),
    },
  ];
};

export const MAX_POSITION = 999999;
